import { useEffect, useState } from "react";

interface LoadingScreenProps {
  message?: string;
}

export default function LoadingScreen({
  message = "Loading...",
}: LoadingScreenProps) {
  const [opacity, setOpacity] = useState(0);

  // Fade in animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(100);
    }, 50);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div
      className={`fixed inset-0 bg-white dark:bg-gray-900 flex flex-col items-center justify-center z-50 transition-opacity duration-300 ease-in-out opacity-${opacity}`}
      style={{ opacity: opacity / 100 }}
    >
      <div className="relative">
        {/* Outer spinner */}
        <div className="w-16 h-16 border-4 border-blue-300 border-t-blue-600 rounded-full animate-spin"></div>

        {/* Inner spinner */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="w-8 h-8 border-4 border-blue-300 border-b-blue-600 rounded-full animate-spin-reverse"></div>
        </div>
      </div>

      {message && (
        <p className="mt-6 text-gray-700 dark:text-gray-300 font-medium text-center max-w-xs animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
}
